import { FC } from 'react';

import { Box } from '@mui/material';

import { CompanyActionsButtons } from '../CompanyActionsButtons';
import { styles } from './styles';

interface MobileCompanyActionsButtonsProps {
  isCreateChannelLoading: boolean;
  isRequestButtons: boolean;
  onRequestQuoteClick?: () => void;
  onRequestSampleClick?: () => void;
  onSendMessageClick?: () => void;
}

export const MobileCompanyActionsButtons: FC<MobileCompanyActionsButtonsProps> = ({
  isCreateChannelLoading,
  isRequestButtons,
  onRequestQuoteClick,
  onRequestSampleClick,
  onSendMessageClick,
}) => {
  return (
    <Box sx={styles.wrap}>
      <CompanyActionsButtons
        isCreateChannelLoading={isCreateChannelLoading}
        isRequestButtons={isRequestButtons}
        onRequestQuoteClick={onRequestQuoteClick}
        onRequestSampleClick={onRequestSampleClick}
        onSendMessageClick={onSendMessageClick}
      />
    </Box>
  );
};
